import React, { useState, useEffect } from 'react';
import { Button, Box, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useNavigate } from 'react-router-dom'; 

const DownloadButton = ({ title, isDownloaded = false, onClick, endIcon }) => {
    const [isAnimating, setIsAnimating] = useState(false);
    const navigate = useNavigate();

    const handleClick = () => {
        setIsAnimating(true); 
        if (onClick) onClick();
    };

    return (
        <Button
            variant="contained"
            onClick={handleClick}
            sx={{
                background: isDownloaded
                    ? '#015e24'
                    : '#02462E',
                color: '#fff',
                padding: '12px 24px',
                width: '707px',
                height: '64px',
                borderRadius: '10px',
                textTransform: 'none',
                fontFamily: 'DM Sans',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '24px',
                position: 'relative',
                overflow: 'hidden',
                transition: 'transform 600ms ease-out, box-shadow 600ms ease-out',
                transform: isAnimating ? 'scale(0.98)' : 'scale(1)',
                '&:hover': {
                    background: isDownloaded ? '#015e24' : '#FEC700',
                    color: isDownloaded ? '#fff' : '#02462E',
                },
            }}
        >
            {/* Centered Title */}
            <Box
                sx={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    textAlign: 'center',
                    pointerEvents: 'none',
                }}
            >
                <Typography
                    sx={{
                        fontFamily: 'DM Sans',
                        fontWeight: 700,
                        fontSize: '24px',
                        lineHeight: '24px',
                        color: '#fff',
                    }}
                >
                    {title}
                </Typography>
            </Box>

            {/* Right-end Icon */}
            <Box sx={{ marginLeft: 'auto', zIndex: 1 }}>
                {endIcon || <DownloadIcon sx={{ fontSize: 28 }} />}
            </Box>
        </Button>
    );
};

export default DownloadButton;
